module.exports = __webpack_public_path__ + "img/icon-add.305cd524.svg";